module.exports = __webpack_public_path__ + "img/ILAC.6f58c090.png";